import cx from 'classnames';

import { Heading } from 'components/Heading';

import { TProfessional } from 'types/appointment';

import { CanvasAnimatedTile } from '../CanvasAnimatedTile';

import s from './TeamMemberTile.module.css';

interface TeamMemberTileProps {
  professional: TProfessional;
  handleBook: (professional: TProfessional) => void;
  staggerColumns?: boolean;
  idx: number;
}

export const TeamMemberTile = ({
  professional,
  handleBook,
  staggerColumns,
  idx,
}: TeamMemberTileProps) => {
  const isBookingEnabled =
    professional.available_for_booking &&
    professional.assigned_services.length > 0;

  const socialLinks: {
    name: keyof TProfessional;
    prefix: string;
    label: string;
  }[] = [
    {
      name: 'instagram_url',
      prefix: 'https://www.instagram.com/',
      label: 'Instagram',
    },
    {
      name: 'facebook_url',
      prefix: 'https://www.facebook.com/',
      label: 'Facebook',
    },
    {
      name: 'twitter_url',
      prefix: 'https://twitter.com/',
      label: 'Twitter',
    },
    {
      name: 'pinterest_url',
      prefix: 'https://www.pinterest.com/',
      label: 'Pinterest',
    },
    {
      name: 'yelp_url',
      prefix: 'https://www.yelp.com/',
      label: 'Yelp',
    },
    {
      name: 'website_url',
      prefix: '',
      label: 'Website',
    },
  ];

  return (
    <div
      className={cx(s.container, {
        [s.staggered]: staggerColumns && idx % 2 !== 0,
      })}
    >
      <div className={s.imageContent}>
        <CanvasAnimatedTile className={s.animatedTile}>
          <img
            className={s.image}
            src={professional.avatar_original}
            alt={professional.full_name}
          />
        </CanvasAnimatedTile>
      </div>
      <div className={s.textContent}>
        <div>
          <Heading as="h2">{professional.full_name}</Heading>
          <p>{professional.about}</p>
          <div className={s.socials}>
            {socialLinks.map(({ name, prefix, label }) => {
              const url = professional[name];

              if (typeof url === 'string' && url) {
                return (
                  <a
                    key={name}
                    href={url.startsWith('http') ? url : `${prefix}${url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </a>
                );
              }

              return null;
            })}
          </div>
        </div>
        <div>
          {isBookingEnabled && (
            <button
              className={s.button}
              onClick={() => handleBook(professional)}
            >
              <span className={s.buttonText}>Book Now</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
